import { IIdentity, TooltipContext } from '.';

export interface TooltipConfig<T extends IIdentity> {
  position?: string;
  disabled?: boolean | ((context: TooltipContext<T>) => boolean);
  message?: string | ((context: TooltipContext<T>) => string);
  onlyTextOverflow?: boolean | ((data: T) => boolean);
  hideOnClick?: boolean;
  /**
   * @description The property the tooltip is based upon.
   * Changes to those property will trigger recompute of tooltip message or disabled status
   */
  property?: string;
  trigger?: string;
}
